<template>
  <!-- start 输入面板 -->
  <div>
    <template v-if="isPaging == false">
      <div class="input-panel" v-for="(items, key) in value" :key="key">
        <div class="show-input-panel">
          <span
            v-for="(item, key) in items"
            :key="key"
            :class="
              item.inputVal != item.key && item.inputVal != null
                ? 'mistake'
                : ''
            "
          >
            <template>{{ item.key }}</template>
          </span>
        </div>
        <div class="input-panel-input">
          <input
            contenteditable="true"
            v-model="inputVals[key]"
            ref="key"
            @keyup="keyboardChangeSeats($event)"
            :disabled="!isEdit"
          />
        </div>
      </div>
    </template>
    <template v-if="isPaging == true">
      <div v-for="(items, key) in value" :key="key">
        <div class="input-panel" v-if="verifyPage(key + 1)">
          <div class="show-input-panel">
            <span
              v-for="(item, key) in items"
              :key="key"
              :class="
                item.inputVal != item.key && item.inputVal != null
                  ? 'mistake'
                  : ''
              "
            >
              <template>{{ item.key }}</template>
            </span>
          </div>
          <div class="input-panel-input">
            <input
              :ref="inputRefName(key)"
              contenteditable="true"
              v-model="inputVals[key]"
              @keyup="keyboardChangeSeats($event,key)"
              :disabled="!isEdit"
              @blur="handleInputBlur(key)"
            />
          </div>
        </div>
      </div>
    </template>
  </div>
  <!-- end 输入面板 -->
</template>

<script>
export default {
  name: "InputPanel",
  data() {
    return {
      inputVals: [],
      val: "",
      page: 1,
      refKey: 0,
      temp: 0,
    };
  },
  props: {
    value: {
      type: Array,
      default: function () {
        return [];
      },
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    isPaging: {
      type: Boolean,
      default: false,
    },
    showLineNumber: {
      type: Number,
      default: 1,
    },
    obtainCursor: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    obtainCursor: {
      handler(newVal) {
        if (newVal == true) {
          let that = this;
          this.$nextTick(() => {
            that.$refs["input-"+that.refKey][0].focus();
          });
        }
      },
    },
    inputVals: {
      handler(newVal) {
        this.value.forEach((item, key) => {
          if (newVal[key] != undefined) {
            let arr = newVal[key].split("");
            this.value[key].forEach((item, keys) => {
              this.value[key][keys].inputVal = arr[keys];
            });
          }
          if (this.automaticPagingPro(this.value, this.page)) {
            // this.page++;
            // let that = this;
            // this.$nextTick(() => {
            //   that.$refs["input-"+that.refKey][0].focus();
            // });
            // this.$emit("pageTurning", this.page);
          }
        });
      },
    },
  },
  methods: {
     // 光标位置
    handleInputBlur(key) {
      if(this.temp != 0){
        this.refKey = this.temp;
        return;
      }
      this.temp = 0; //编辑 关联函数游延迟性
      this.refKey = key;
      console.log("xxxxxxx")
    },
    // input ref 名字
    inputRefName(key){
      //this.refKey = key;
      return 'input-'+key;
    },
    // 验证页码
    verifyPage(key) {
      let startNum = 1 + (this.page - 1) * this.showLineNumber;
      let endNum =
        1 + (this.page - 1) * this.showLineNumber + (this.showLineNumber - 1);
      if (startNum <= key && endNum >= key) {
        return true;
      }
      return false;
    },
    // 按键字符
    keyboardChangeSeats(event) {
      if (this.automaticPagingPro(this.value, this.page) && event.key == 'Enter') {
          this.$emit("keyboardChangeSeats", event,true);
          this.page++;
          let that = this;
          if(this.showLineNumber == 1){
            this.refKey = 1 + (this.page - 1) * this.showLineNumber - 1;
          }else{
            //this.refKey = 0;
            this.refKey = 1 + (this.page - 1) * this.showLineNumber -1;
          }
          this.temp = this.refKey;
          this.$nextTick(() => {
            that.$refs["input-"+that.refKey][0].focus();
          });
          this.$emit("pageTurning", this.page);
          return;
       }
      this.$emit("keyboardChangeSeats", event);
    },
    // 翻页
    automaticPagingPro(data, page) {
      let startNum = 1 + (page - 1) * this.showLineNumber;
      let endNum =
        1 + (page - 1) * this.showLineNumber + (this.showLineNumber - 1);
      let totalNum = Math.ceil(data.length / this.showLineNumber);
      if (page >= totalNum) {
        return false;
      }
      let total = 0;
      let inputLength = 0;
      data.forEach((item, key) => {
        if (startNum <= key + 1 && endNum >= key + 1) {
          item.forEach((items) => {
            total++;
            if (items.inputVal != null) {
              inputLength++;
            }
          });
        }
      });
      if (total <= inputLength) {
        return true;
      }
      return false;
    },
    // 翻页
    automaticPaging(data, total) {
      let characterSize = data.length;
      let inputLength = 0;
      if (this.page >= total) {
        return false;
      }
      data.forEach((item) => {
        if (item.inputVal != null) {
          inputLength++;
        }
      });
      if (characterSize <= inputLength) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped lang="scss">
.input-panel {
  width: 898px;
  height: 73px;
  background: #fbfbfb;
  box-shadow: inset 0px 0px 5px 1px rgba(0, 0, 0, 0.2);
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  border: 1px solid #dbdbdb;
  padding: 10px 10px;
  box-sizing: border-box;
  margin-bottom: 8px;
  span {
    padding: 0px;
  }
  .show-input-panel {
    letter-spacing: 2px;
    width: 100%;
    color: #000000;
    font-weight: 400;
    font-family: Meiryo-Regular, Meiryo;
    font-size: 18px;
    word-spacing: 12px;
    padding: 0 0;
  }
  .input-panel-input {
    width: 100%;
    margin-top: 5px;
    input {
      color: #9d9d9d;
      width: 100%;
      font-weight: 400;
      font-size: 18px;
      background: none;
      outline: none;
      border: none;
      padding: 0;
      letter-spacing: 2px;
      font-family: Meiryo-Regular, Meiryo;
      word-spacing: 12px;
    }
    // input {
    //   width:12px;
    //   background: none;
    //   outline: none;
    //   border: none;
    //   padding: 0;
    //   font-weight: 400;
    //   font-size: 18px;
    //   letter-spacing: 2px;
    //   font-family: Meiryo-Regular, Meiryo;
    //   word-spacing: 12px;
    // }
  }
  .mistake {
    color: red;
  }
}
</style>
